import { Trans } from 'react-i18next';
import { useSelector } from 'react-redux';

import { getIsFetchingInitialData } from '@app/store/pending/selectors';
import { getHasFreeSpace, getUserCanUpgrade } from '@app/store/user/selectors';

import { Alert } from '../Alert';

export type Props = {
  className?: string;
};

export const Storage = ({ className }: Props) => {
  const userCanUpgrade = useSelector(getUserCanUpgrade);
  const isFetchingInitialData = useSelector(getIsFetchingInitialData);
  const userHasSpaceLeft = useSelector(getHasFreeSpace);

  if (userHasSpaceLeft || isFetchingInitialData) {
    return null;
  }

  return (
    <Alert variant="danger" className={className}>
      {userCanUpgrade ? (
        <Trans i18nKey="storage.alert.free">
          You’re out of storage. Delete some items that don’t spark joy, or
          upgrade to Collect Pro in one of our Collect Apps.
        </Trans>
      ) : (
        <Trans i18nKey="storage.alert.pro">
          You’re out of storage. Delete some items that don’t spark joy, or
          contact Support to keep adding items.
        </Trans>
      )}
    </Alert>
  );
};
